var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRotateRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bold/rotate-right"
  }, /*#__PURE__*/React.createElement("g", {
    id: "rotate-right"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.793 1.33325H5.20634C2.77967 1.33325 1.33301 2.77992 1.33301 5.20658V10.7866C1.33301 13.2199 2.77967 14.6666 5.20634 14.6666H10.7863C13.213 14.6666 14.6597 13.2199 14.6597 10.7933V5.20658C14.6663 2.77992 13.2197 1.33325 10.793 1.33325ZM7.99967 12.3866C5.88634 12.3866 4.16634 10.6666 4.16634 8.55325C4.16634 6.47992 5.81967 4.79325 7.87301 4.71992L7.62634 4.43325C7.44634 4.22659 7.46634 3.90659 7.67301 3.72659C7.87967 3.54659 8.19967 3.56659 8.37967 3.77325L9.48634 5.03992C9.49967 5.05325 9.50634 5.06659 9.51967 5.07992C9.54634 5.11992 9.57301 5.16659 9.58634 5.21325C9.59301 5.23992 9.59967 5.26659 9.60634 5.29325C9.61967 5.35325 9.61301 5.41992 9.59967 5.47992C9.58634 5.53325 9.56634 5.58659 9.53967 5.63992C9.53301 5.65325 9.51968 5.66659 9.51301 5.67992C9.48634 5.71992 9.44634 5.75325 9.40634 5.77992C9.40634 5.77992 9.39968 5.77992 9.39968 5.78659L8.10634 6.73325C7.87967 6.89325 7.57301 6.84658 7.40634 6.62658C7.24634 6.40658 7.29301 6.09325 7.51301 5.92659L7.78634 5.72658C6.31967 5.83325 5.15967 7.05992 5.15967 8.55325C5.15967 10.1133 6.43301 11.3866 7.99301 11.3866C9.55301 11.3866 10.8263 10.1133 10.8263 8.55325C10.8263 7.99325 10.6597 7.44659 10.353 6.97992C10.1997 6.75325 10.2597 6.43992 10.493 6.28659C10.7263 6.13325 11.033 6.19325 11.1863 6.42659C11.6063 7.05992 11.833 7.79325 11.833 8.55325C11.833 10.6666 10.113 12.3866 7.99967 12.3866Z",
    fill: "#F15B5B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRotateRight);
export default __webpack_public_path__ + "static/media/rotate-right.cab512f02895849ec9ff72321b4778c7.svg";
export { ForwardRef as ReactComponent };